import Highcharts from 'highcharts'
import VariablePieAddOn from 'highcharts/modules/variable-pie'
import Accessibility from 'highcharts/modules/accessibility'

VariablePieAddOn(Highcharts)
Accessibility(Highcharts)

/**
 * Instancia de Highcharts con módulos necesarios para gráficos tipo variable-pie.
 * Usar solo en PieChart para no interferir con otros tipos de gráficos.
 */
export default Highcharts
